import React, { useState } from 'react';

import {
  imageLoader,
  loadAllImages
} from '../renderer/imageLoader';

function ImagePrefetcher(props: {
  urls: string[];
  onLoaded?: () => void;
}) {
  const [loaded, setLoaded] = useState({count: 0});

  const load = async (urls: string[]) => {
    urls.map(async (url) => {
      console.log(url)
      await imageLoader(url);
      loaded.count += 1;
      setLoaded({count: loaded.count});
    });
  }

  React.useEffect(() => {
    load(props.urls);
  }, []);
  return (
    <div className="ImagePrefetcher">
      <progress value={loaded.count} max={props.urls.length} />
      {(loaded.count < props.urls.length) && <div>prefetching assets...</div>}
      {(loaded.count >= props.urls.length) && <div>prefetch completed. assets cached.</div>}
    </div>
  )
}

export {
  ImagePrefetcher
}